import { create } from 'zustand';

interface OpenAccountAvailabilityState {
  openSpotIsAvailable: boolean;
  openInvestIsAvailable: boolean;
  openMarginIsAvailable: boolean;
  openEarnIsAvailable: boolean;
  spotCreateIsActive: boolean;
  investCreateIsActive: boolean;
  marginCreateIsActive: boolean;
  earnCreateIsActive: boolean;
  setAccountsCreateAvailability: (
    spot: boolean,
    invest: boolean,
    margin: boolean,
    earn: boolean
  ) => void;
  setAccountsCreateActive: (
    spot: boolean,
    invest: boolean,
    margin: boolean,
    earn: boolean
  ) => void;
}

const useOpenAccountAvailabilityStore = create<OpenAccountAvailabilityState>(
  set => ({
    openSpotIsAvailable: false,
    openInvestIsAvailable: false,
    openMarginIsAvailable: false,
    openEarnIsAvailable: false,
    spotCreateIsActive: false,
    investCreateIsActive: false,
    marginCreateIsActive: false,
    earnCreateIsActive: false,
    setAccountsCreateAvailability: (
      spot: boolean,
      invest: boolean,
      margin: boolean,
      earn: boolean
    ) =>
      set({
        openSpotIsAvailable: spot,
        openInvestIsAvailable: invest,
        openMarginIsAvailable: margin,
        openEarnIsAvailable: earn,
      }),
    setAccountsCreateActive: (
      spot: boolean,
      invest: boolean,
      margin: boolean,
      earn: boolean
    ) =>
      set({
        spotCreateIsActive: spot,
        investCreateIsActive: invest,
        marginCreateIsActive: margin,
        earnCreateIsActive: earn,
      }),
  })
);

export { useOpenAccountAvailabilityStore };
